module.exports = __webpack_public_path__ + "static/media/Formular-Black.0772ee85.woff";